import PropTypes from "prop-types";

// MUI
import { Dialog, Grid, IconButton, Paper } from "@mui/material";

// Custom components
import PdfPayPlanLayer from "@/PayPlans/views/Layers/Html/Sales/Associates";

// Icons
import CloseIcon from "@mui/icons-material/Close";

export default function GroupDialog(props) {
	const { payPlanSelected = null, open = false, onCloseAction = () => {} } = props;

	return (
		<Dialog open={open} disableEscapeKeyDown onClose={onCloseAction} className="select-plan-dialog">
			<Paper elevation={0} sx={{ padding: "35px 0px", height: "100%", borderRadius: "20px" }}>
				<Grid container className={"add-vertical-scroll-behavior"} sx={{ padding: "0 30px" }}>
					<IconButton
						onClick={onCloseAction}
						aria-label="close"
						sx={{
							position: "absolute",
							top: "10px",
							right: "10px",
						}}
					>
						<CloseIcon />
					</IconButton>
					<PdfPayPlanLayer assignment={true} selected={payPlanSelected} />
				</Grid>
			</Paper>
		</Dialog>
	);
}
GroupDialog.propTypes = {
	payPlanSelected: PropTypes.object,
	open: PropTypes.bool,
	onCloseAction: PropTypes.func,
};
